import { Box } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel, ColorSchema, useMinimalsTheme } from '@tom-ui/ui'
import { useMemo } from 'react'
import { ReleaseStatus } from '../../models/ReleaseStatus'

interface Props {
  status: ReleaseStatus
}
export const ReleaseStatusChip = ({ status }: Props) => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  const currentStatus: { label: string; color: ColorSchema } = useMemo(() => {
    switch (status) {
      case ReleaseStatus.InProgress:
        return { label: t('inProgress', 'In progress'), color: 'busy' }
      case ReleaseStatus.Open:
        return { label: t('open', 'Open'), color: 'info' }
      case ReleaseStatus.Fulfilled:
        return { label: t('fulfilled', 'Fulfilled'), color: 'secondary' }
    }
  }, [status, t])

  return (
    <Box>
      <ColoredLabel
        label={currentStatus.label}
        color={currentStatus.color}
        sx={{
          width: 'fit-content',
          backgroundColor: theme.palette[currentStatus.color].lighter,
        }}
      />
    </Box>
  )
}
